import { Link } from "react-router-dom";
import PortalLayout from "../../components/PortalLayout";
import { useI18n } from "../../i18n/LanguageContext";
import { COMPLIANCE } from "./exploreContent";

export default function ExploreCompliancePage() {
  const { locale, t } = useI18n();
  const c = COMPLIANCE[locale] || COMPLIANCE.it;

  return (
    <PortalLayout>
      <section
        className="max-w-[920px] mx-auto px-6 sm:px-8 pt-14 pb-8"
        data-testid="explore-compliance-page"
      >
        <Link
          to="/explore"
          className="font-mono-fin text-[0.7rem] tracking-[0.2em] uppercase text-[color:var(--br-bronze-soft)] hover:text-[color:var(--br-bronze)]"
          data-testid="explore-back-link"
        >
          {t("explore.back")}
        </Link>

        <div className="br-fade-up mt-7">
          <div className="br-overline">{c.eyebrow}</div>
          <h1 className="font-serif-display text-[clamp(2.2rem,4.3vw,3.5rem)] mt-3 leading-[1.05]">
            {c.title}
          </h1>
          <p className="text-[1.02rem] text-[color:var(--br-text)] mt-5 leading-relaxed max-w-[720px]">
            {c.sub}
          </p>
        </div>

        <div className="mt-10 space-y-6 br-fade-up br-delay-1">
          {/* Firm block */}
          <div className="br-card p-7" data-testid="compliance-firm-block">
            <h2 className="font-serif-display text-[1.5rem] text-[color:var(--br-parchment)] mb-5">
              {c.firm_block_t}
            </h2>
            <dl className="grid sm:grid-cols-[180px_1fr] gap-y-3 gap-x-6">
              {c.firm_rows.map(([dt, dd], i) => (
                <FirmRow key={i} dt={dt} dd={dd} />
              ))}
            </dl>
          </div>

          {/* Sections */}
          {c.sections.map((s, i) => (
            <div
              key={i}
              className="br-card p-7"
              style={
                s.warn
                  ? {
                      borderLeft: "3px solid var(--br-red)",
                      background: "rgba(179,107,107,0.04)",
                    }
                  : undefined
              }
              data-testid={`compliance-section-${i}`}
            >
              <h2
                className="font-serif-display text-[1.4rem] mb-4"
                style={{ color: s.warn ? "var(--br-red)" : "var(--br-parchment)" }}
              >
                {s.t}
              </h2>
              <p className="text-[0.96rem] text-[color:var(--br-text)] leading-relaxed">{s.d}</p>
            </div>
          ))}
        </div>
      </section>
    </PortalLayout>
  );
}

function FirmRow({ dt, dd }) {
  return (
    <>
      <dt className="font-mono-fin text-[0.66rem] tracking-[0.22em] uppercase text-[color:var(--br-text-dim)] self-center">
        {dt}
      </dt>
      <dd className="text-[0.98rem] text-[color:var(--br-parchment)] font-mono-fin">{dd}</dd>
    </>
  );
}
